import timg2 from '../images/case/hetram-jangu.jpg'
import timg3 from '../images/case/dinesh.JPG'
import pImg6 from '../images/case/jagdish.jpg'


const Teams = [
   {
      Id: '4',
      tImg: pImg6,
      name: 'Jagdish Prasad',
      slug: 'jagdish-prasad',
      title: 'Founder & CEO',
   },
   {
      Id: '5',
      tImg: timg2,
      name: 'Hetram Janghu',
      slug: 'hetram-janghu',
      title: 'Full-Stack Developer',
   },
   {
      Id: '6',
      tImg: timg3,
      name: 'Dinesh Kaswan',
      slug: 'dinesh-kaswan',
      title: 'Senior Software Engineer',
   },
   
]

export default Teams;